export default {
  getUserMd5Id(user_id) {
    return CryptoJS.MD5(user_id).toString(CryptoJS.enc.Hex);
  }
};
